var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.57164 0.269651L14.999 13.6972L28.4284 0.269651C28.7879 -0.0898837 29.3708 -0.0898837 29.7304 0.269651C30.0899 0.629186 30.0899 1.21211 29.7304 1.57164L16.3008 14.999L29.7304 28.4284C30.0899 28.7879 30.0899 29.3708 29.7304 29.7304C29.3708 30.0899 28.7879 30.0899 28.4284 29.7304L14.999 16.3008L1.57164 29.7304C1.21211 30.0899 0.629186 30.0899 0.269651 29.7304C-0.0898837 29.3708 -0.0898837 28.7879 0.269651 28.4284L13.6972 14.999L0.269651 1.57164C-0.0898837 1.21211 -0.0898837 0.629186 0.269651 0.269651C0.629186 -0.0898837 1.21211 -0.0898837 1.57164 0.269651Z",
    fill: "#F50014"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.1fde3e4d3da5700c7cafee76267df682.svg";
export { ForwardRef as ReactComponent };